/* eslint-disable prettier/prettier */
import moment from "moment";

import qs from "qs";
import axios from "axios";
import {
    _
} from "core-js";

axios.defaults.withCredentials = true;

export class BookingForm {
    constructor(rideTypes, secondParam, store) {
        console.log("Constructing booking form");

        this.rideTypes = rideTypes;

        console.log(this.rideTypes);

        this.user = BookingForm.emptyUser();

        this.store = store;

        this.errors = this.emptyErrors();

        this.loading = false;

        if (typeof secondParam === "string") {
            // TODO lookup number to try and find a user!

            // set booking to an empty booking!
            this.user = BookingForm.emptyUser();
            this.booking = BookingForm.emptyBooking();

            console.log(secondParam);

            if (secondParam != "") {
                console.log("Getting customer when constructing form");
                this.getCustomer(secondParam);
            }

            this.booking.ride_type = this.rideTypes[0].id;

            this.costs = [];
        } else {
            this.booking = secondParam.booking;
            this.user = secondParam.user;
            this.reviews = secondParam.reviews;

            // TODO get estimated costs
            this.costs = [];

            try {
                this.getCostEstimate();
            } catch (e) {
                console.log(e);
            }

        }
    }

    FIXED_COST_DISPATCHER() {
        return "fixed_cost_dispatcher";
    }

    FIXED_COST_AREA() {
        return "fixed_cost_area";
    }

    static emptyUser() {
        return {
            name: "",
            contact_number: "44",
            cards: [],
            promocodes: [],
            business: false,
            business_pickup_address: {},
            notes: "",
            recent_bookings: [],
            active_bookings: [],
            booked_bookings: [],
            locked_out: false
        };
    }

    emptyErrors() {
        return {
            name: null,
            contact_number: null,
            pickup_time: null,
            additional_charge: null,
            final_cost: null,
            final_cost_driver: null,
            pickup_location: null,
            destinations: null,
            num_people: null,
            luggage: null,
            promocode: null,
            ride_type: null,
            payment_type: null,
            preassigned_driver: null,
            card: null,
            pickup_time: null,

        }
    }

    static emptyBooking() {

        var date = new Date();
        var newDate = new Date(date.getTime());

        var pickup_date = moment(newDate).format("YYYY-MM-DD");
        var pickup_time = moment(newDate).format("HH:mm");

        return {
            bestDriver: null,
            asap: true,
            pickup_datetime: null,
            pickup_time: pickup_time,
            pickup_date: pickup_date,
            business_customer_name: "",
            business_customer_number: "",
            business_customer_email: "",
            business_customer_reference: "",
            predefinedMessage: null,
            pickup_location: {},
            pickup_info: BookingForm.emptyViaInfo(),
            destination_info: BookingForm.emptyViaInfo(),
            destinations: [{}],
            via_info: [],
            promocode: null,
            ride_type: null,
            taxi_type: null,
            num_people: BookingForm.DEFAULT_PAX(),
            luggage: null,
            needs_disabled_access: false,
            needs_pets: false,
            premium: false,
            flight_number: null,
            room_number: null,
            meet_and_greet: false,
            payment_type: BookingForm.DEFAULT_PAYMENT_TYPE(),
            card: null,
            additional_charge: 0,
            fixed_cost: false,
            final_cost: null,
            fixed_cost_driver: false,
            final_cost_driver: null,
            notes: "",
            message: "",
            route: {
                time: null,
                distance_in_miles: null
            },
            eligibleDriversForPreassign: [],
            manual_dispatch: false,
            fixedCostType: null,
            fixedCostDriverType: null,
            state: null,
            authorized_by: null,
        };
    }

    static emptyViaInfo() {
        return {
            active: false,
            name: "",
            contact_number: "",
            notes: ""
        };
    }

    static VEHICLE_TYPES() {
        return [{
            name: "Sal",
            type: "Saloon"
        },
        {
            name: "Est",
            type: "Estate"
        }, {
            name: "Mpv",
            type: "Mpv"
        }
        ];
    }

    static PAYMENT_TYPES() {
        return [{
            name: "Cash",
            type: "cash"
        },
        {
            name: "Card",
            type: "card"
        },
        {
            name: "Card in Cab",
            type: "card_in_cab"
        },
        {
            name: "Account",
            type: "account"
        }
        ];
    }

    paymentTypes() {
        return BookingForm.PAYMENT_TYPES();
    }

    static DEFAULT_PAX() {
        return 4;
    }

    static DEFAULT_PAYMENT_TYPE() {
        return "cash";
    }

    clearCards() { }

    clearPromocodes() { }

    swapPickupAndDestination() {
        var tempDestination = this.booking.destinations[0];

        this.booking.destinations[0] = this.booking.pickup_location;
        this.booking.pickup_location = tempDestination;

        this.getCostEstimate();

        try {
            this.getBestDriver();
        } catch (e) {
            console.log("Error getting best driver");
            console.log(e);
        }
    }

    addVia() {
        if (this.booking.destinations.length < 8) {
            this.booking.destinations.push({});
        }

        this.booking.via_info.push(BookingForm.emptyViaInfo());
    }

    updatePassengerCount() { }

    checkCanEstimateCosts(booking) {
        return true;
    }

    gotCostEstimate(response) {
        console.log("Got cost estimates");

        this.loading = false;

        this.costs = response.costs;
        this.booking.route.distance_in_miles = response.distance_in_miles;
        console.log("Distance in miles " + this.booking.route.distance_in_miles);
        this.booking.route.time = response.time;

        this.updateFixedCosts();
    }

    getBestDriver() {
        console.log("Get best driver called");

        if (this.booking.state != null) {
            return;
        }

        this.booking.bestDriver = null;
        this.loadingBestDriver = true;

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log("Error");
            console.log(e);
            return;
        }

        var errors = this.errors;

        console.log("Getting best drivers for preassign");

        var vm = this;

        if (booking.pickup_time == "Invalid date") {
            booking.asap = true;
            booking.pickup_time = moment(new Date()).format("YYYY-MM-DD HH:mm");
        }

        var url = `${this.store.state.apiUrl}/overwatch/getBestDriverForBooking`;

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                booking: booking
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loadingBestDriver = false;

                if (res.data.error == "no_error") {
                    vm.booking.bestDriver = res.data.driver;
                    vm.booking.bestDriver.minutesFromPickup = res.data.minutes_from_pickup;
                } else {
                    console.log(res.data.errors);
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loadingBestDriver = false;
                console.error(err);
            });
    }

    getCostEstimate() {
        console.log("Get cost estimate called");

        var canEstimateCosts = this.checkCanEstimateCosts(this.booking);

        this.booking.costs = [];
        this.loading = true;

        if (canEstimateCosts) {

            try {
                this.getBestDriver();
            } catch (e) {
                console.log(e);
            }

            console.log('Getting estimated costs...');

            var url = `${this.store.state.apiUrl}/booking/getCostEstimate`;

            url += `?pickupLocation=${this.booking.pickup_location.id}`;

            for (let i = 0; i < this.booking.destinations.length; i++) {
                if (this.booking.destinations[i].id != null) {
                    url += `&destinationLocation=${this.booking.destinations[i].id}`;
                }
            }

            if (!this.booking.asap && this.booking.pickup_datetime != null && this.booking.pickup_datetime.isValid()) {
                url += `&pickupTime=${moment(this.booking.pickup_datetime).format("YYYY-MM-DD HH:mm")}`;
            }

            url += `&paymentType=${this.booking.payment_type}`;

            if (this.booking.promocode != null) {
                url += `&promocode=${this.booking.promocode}`;
            }

            url += `&phone=${this.user.contact_number}`;

            if (this.booking.additional_charge != null && !isNaN(this.booking.additional_charge)) {
                url += `&additionalCharge=${((this.booking.additional_charge == null ? 0 : this.booking.additional_charge) * 100).toFixed(0)}`;
            }

            console.log(url);

            let completed = this.gotCostEstimate.bind(this);

            var vm = this;

            axios({
                url: url,
                method: 'GET',
                params: {},
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            })
                .then(function (res) {
                    completed(res.data);
                })
                .catch(function (err) {
                    vm.loading = false;
                    console.error(err);
                });
        } else {
            console.log('Cannot get estimated costs');
            this.loading = false;
        }
    }

    setEligibleDriversForPreassigned(drivers) {

        this.booking.eligibleDriversForPreassign.length = 0;

        for (var i = 0; i < drivers.length; i++) {
            drivers[i].idname =
                drivers[i].callsign + " " + drivers[i].name;
            this.booking.eligibleDriversForPreassign.push(drivers[i]);

        }

        console.log("Got " + drivers.length);
        console.log(drivers);
    }

    getEligibleDriversForPreassign() {
        var url = `${this.store.state.apiUrl}/overwatch/getEligibleDriversForPreassign`;

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log("Error");
            console.log(e);
            return;
        }

        var errors = this.errors;

        console.log("Getting eligible drivers for preassign");

        var vm = this;

        if (booking.pickup_time == "Invalid date") {
            booking.asap = true;
            booking.pickup_time = moment(new Date()).format("YYYY-MM-DD HH:mm");
        }

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                booking: booking
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                if (res.data.error == "no_error") {
                    vm.setEligibleDriversForPreassigned(res.data.drivers);
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                console.error(err);
            });
    }

    updateCostEstimate() { }

    saveAsQuote() { }

    addPromocode() { }

    addCard() { }

    removeCard() { }

    book() { }

    addReturn() { }

    update() { }

    changePaymentType(paymentType, card) {
        this.booking.payment_type = paymentType;

        if (paymentType == "card" && card == null) {
            // choose card in list!
            if (this.user.cards != null && this.user.cards.length > 0 && this.booking.card == null) {
                this.booking.card = this.user.cards[0].id;
            }
        } else {
            this.booking.card = card;
        }

        if (paymentType != "card") {
            console.log("Setting card and promocode to null");
            this.booking.promocode = null;
            this.booking.card = null;
        }

        this.getCostEstimate();
    }

    changePromocode(promocode) {
        if (this.booking.payment_type == 'card') {
            this.booking.promocode = promocode;
            this.getCostEstimate();
        }
    }

    changeRideType(rideType) {
        this.booking.ride_type = rideType;

        var rideTypeObj = this.rideTypes.find(function (r) {
            return r.id == rideType;
        })

        this.booking.needs_disabled_access = rideTypeObj.disabledAccess;
        this.booking.premium = rideTypeObj.premiumVehicle;
        this.booking.num_people = rideTypeObj.numSeats;

        this.updateFixedCosts();

        try {
            this.getBestDriver();
        } catch (e) {
            console.log("Error getting best driver");
            console.log(e);
        }

        console.log("Changed ride type");
    }

    updateFixedCosts() {
        try {

            var booking = this.booking;

            var estimatedCost = this.costs.find(function (cost) {
                return cost.id == booking.ride_type;
            });

            if (estimatedCost == null) {
                return;
            }

            if (estimatedCost.fixed_cost != null) {

                if (this.booking.fixedCostType == null || this.booking.fixedCostType == this.FIXED_COST_AREA()) {
                    this.booking.fixed_cost = true;
                    this.booking.final_cost = (estimatedCost.estimate / 100);
                    this.booking.fixedCostType = this.FIXED_COST_AREA();
                }

                if ((this.booking.fixedCostDriverType == null && estimatedCost.final_cost_driver != null) || (this.booking.fixedCostDriverType == this.FIXED_COST_AREA() && estimatedCost.final_cost_driver != null)) {
                    this.booking.fixed_cost_driver = true;
                    this.booking.final_cost_driver = (estimatedCost.final_cost_driver / 100);
                    this.booking.fixedCostDriverType = this.FIXED_COST_AREA();
                    console.log("Setting fixed cost driver to true");
                    console.log(estimatedCost.final_cost_driver);
                }
            } else if (booking.state == null || (booking.state != 'cancelled' && booking.state != 'completed')) {
                if (this.booking.fixedCostType == null || this.booking.fixedCostType == this.FIXED_COST_AREA()) {
                    this.booking.fixed_cost = false;
                    this.booking.final_cost = null;
                    this.booking.fixedCostType = null;
                }

                if (this.booking.fixedCostDriverType == null || this.booking.fixedCostDriverType == this.FIXED_COST_AREA()) {
                    this.booking.fixed_cost_driver = false;
                    this.booking.final_cost_driver = null;
                    this.booking.fixedCostDriverType = null;
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    toggleAsap() {
        this.booking.asap = !this.booking.asap;

        if (!this.booking.asap) {
            this.setPickupTimeAhead(15);
            return;
        }

        this.checkPromocodeStillActive();
        this.getCostEstimate();
    }

    updateDate() {

        console.log("Date updated");

        this.booking.asap = false;

        var date = moment.utc(
            this.booking.pickup_date + " " + this.booking.pickup_time,
            "YYYY-MM-DD HH:mm", true
        );

        console.log(date);

        this.booking.pickup_datetime = date;

        console.log("Updated date " + date.toISOString());

        if (date == null) {
            return;
        }

        // if (date.isBefore(moment(new Date(date.getTime() + 15 * 60000)))) {
        //     return;
        // }

        console.log("getting cost estimate for date");

        this.checkPromocodeStillActive();
        this.getCostEstimate();
    }

    setPickupTimeAhead(minutes) {

        console.log("Set pickup time ahead");

        this.booking.asap = false;

        var date = new Date();
        var newDate = new Date(date.getTime() + minutes * 60000);

        this.booking.pickup_datetime = moment(newDate);

        this.booking.pickup_date = moment(newDate).format("YYYY-MM-DD");
        this.booking.pickup_time = moment(newDate).format("HH:mm");

        this.checkPromocodeStillActive();
        this.getCostEstimate();
    }

    clear() {
        this.booking = BookingForm.emptyBooking();

        this.booking.ride_type = this.rideTypes[0].id;
        this.costs = [];
    }

    async getCustomer(contactNumber) {
        this.clearCustomer();

        try {
            var url = `${
                this.store.state.apiUrl
                }/customer/getCustomerDetailsForMakeBooking?contact_number=${contactNumber}`;

            let response = await axios.get(url, {
                params: {}
            });

            console.log("Getting customer");

            if (response.data.error == null || response.data.error == "no_error") {
                this.user.cards = response.data.cards;
                this.user.promocodes = response.data.promocodes;
                this.user.business = response.data.business;
                this.user.business_pickup_address =
                    response.data.business_pickup_address;
                this.user.notes = response.data.notes;
                this.user.recent_bookings = response.data.recent_bookings;
                this.user.active_bookings = response.data.active_bookings;
                this.user.booked_bookings = response.data.booked_bookings;
                this.user.locked_out = response.data.locked_out;

                this.user.name = response.data.name;
                this.user.contact_number = response.data.contact_number;

                this.errors.name = null;
                this.errors.contact_number = null;

                this.user.business_payment_type = response.data.business_payment_type;

                if (this.booking.id == null && this.user.business_pickup_address != null && this.booking.pickup_location.id == null) {
                    console.log("Setting pickup location from business");
                    this.booking.pickup_location.id = this.user.business_pickup_address.location.id;
                    this.booking.pickup_location.description = this.user.business_pickup_address.location.description;
                    this.booking.pickup_location.latLng = {
                        latitude: this.user.business_pickup_address.location.lat,
                        longitude: this.user.business_pickup_address.location.lon,
                    }
                }

                if (this.booking.id == null && this.user.business_payment_type != null) {
                    this.booking.payment_type = this.user.business_payment_type;

                    if (this.booking.payment_type == 'card' && this.user.cards != null && this.user.cards.length > 0) {
                        this.booking.card = this.user.cards[0].id;
                    }
                }


                this.getCostEstimate();
            } else {
                console.log("Customer not found")
                this.user.contact_number = contactNumber;
            }

        } catch (error) {
            this.loading = false;
            console.log("Failed to get customer " + error);
        }

    }

    clearCustomer() {
        console.log("Clearing customer");

        this.user.cards = [];
        this.user.promocodes = [];
        this.user.business = false;
        this.user.business_pickup_address = {};
        this.user.notes = "";
        this.user.recent_bookings = [];
        this.user.active_bookings = [];
        this.user.locked_out = false;

        this.booking.promocode = null;
        this.booking.card = null;

        // this.booking.payment_type = BookingForm.DEFAULT_PAYMENT_TYPE();

    }

    checkPromocodeStillActive() {
        if (this.booking.promocode == null) {
            return;
        }

        var booking = this.booking;

        var promocode = this.user.promocodes.find(function (p) {
            return p.id == booking.promocode;
        });

        if (promocode == null) {
            return;
        }

        if (!this.promocodeWillBeActive(promocode)) {
            console.log("Clearing promocode as it would no longer be active");
            this.booking.promocode = null;
        };
    }

    promocodeWillBeActive(p) {
        var pickupTime;

        var booking = this.booking;

        if (booking.asap) {
            pickupTime = new Date();
        } else {
            pickupTime = booking.pickup_datetime;
        }

        var pickupTimeMoment = moment(pickupTime);

        var promocodeExpiry = moment(p.expiry_date, "DD/MM/YYYY HH:mm");
        var promotionExpiry = moment(
            p.promocode.promotion.end_date,
            "DD/MM/YYYY HH:mm"
        );

        return (
            pickupTimeMoment.isBefore(promocodeExpiry) &&
            pickupTimeMoment.isBefore(promotionExpiry)
        );
    }

    rebook(b) {

        console.log(this.booking);

        var asap = this.booking.asap;

        var pickup_date = this.booking.pickup_date;
        var pickup_time = this.booking.pickup_time;

        var out = BookingForm.jsonToBookingFormBookingUser({
            booking: b
        });

        this.booking = out.booking;
        this.booking.state = null;
        this.booking.additional_charge = 0;

        this.booking.asap = asap;

        this.booking.pickup_date = pickup_date;
        this.booking.pickup_time = pickup_time;

        if (!this.booking.asap) {
            this.updateDate();
        }

        if (this.booking.ride_type == null || this.booking.ride_type == undefined) {
            this.booking.ride_type = this.rideTypes[0].id;
        }

        if (this.booking.fixed_cost != true) {
            this.booking.fixed_cost = false;
            this.booking.final_cost = null;
        }

        this.getCostEstimate();

    }

    copy(b) {

        var out = BookingForm.jsonToBookingFormBookingUser({
            booking: b
        });

        this.booking = out.booking;
        this.booking.state = null;
        this.booking.additional_charge = 0;

        console.log("Booking to copy");
        console.log(b);

        if (this.booking.fixed_cost != true) {
            this.booking.fixed_cost = false;
            this.booking.final_cost = null;
        }

        this.getCustomer(b.customer_number);
    }


    locationCMRToLocationBookingForm(l) {
        return {
            id: l.id,
            description: l.description,
            latLng: {
                latitude: l.lat,
                longitude: l.lon
            },
            active: true,
        };
    }

    validateRide() {

        console.log("Validate ride called");

        this.errors = this.emptyErrors();

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking, true, true);
        } catch (e) {
            console.log(e);
            this.loading = false;
            return false;
        }

        for (var property in this.errors) {
            if (this.errors.hasOwnProperty(property)) {
                if (this.errors[property] != null) {
                    console.log("Validate Ride Errors:");
                    console.log(this.errors);
                    return false;
                }
            }
        }


        return true;
    }

    bookRide(done) {

        this.loading = true;

        console.log("Book ride called");

        var url = `${this.store.state.apiUrl}/booking/makeBooking`;

        var user = null;

        this.errors = this.emptyErrors();

        var error = false;

        if (this.user.name == null || this.user.name.length == 0) {
            this.errors.name = "Enter name for customer";

            error = true;
        }

        if (this.user.contact_number == null || this.user.contact_number.length == 0) {
            this.errors.contact_number = "Enter contact number for customer";

            error = true;
        }

        if (error == true) {
            this.loading = false;
            return;
        }

        user = {
            name: this.user.name,
            contact_number: this.user.contact_number,
            notes: this.user.notes,
        };

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log(e);
            this.loading = false;
            return;
        }

        var errors = this.errors;

        var vm = this;

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                user: user,
                booking: booking
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loading = false;

                if (res.data.error == "no_error") {
                    done();
                } else {
                    var errorsFromServer = res.data.errors;

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");
                        alert(errors.error);
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loading = false;
                console.error(err);
            });

    }

    backdateRide(done) {

        this.loading = true;

        console.log("Backdate ride called");

        var url = `${this.store.state.apiUrl}/booking/backdateBooking`;

        var user = null;

        this.errors = this.emptyErrors();

        var error = false;

        if (this.user.name == null || this.user.name.length == 0) {
            this.errors.name = "Enter name for customer";

            error = true;
        }

        if (this.user.contact_number == null || this.user.contact_number.length == 0) {
            this.errors.contact_number = "Enter contact number for customer";

            error = true;
        }

        if (error == true) {
            this.loading = false;
            return;
        }

        user = {
            name: this.user.name,
            contact_number: this.user.contact_number,
            notes: this.user.notes,
        };

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log(e);
            this.loading = false;
            return;
        }

        var errors = this.errors;

        var vm = this;

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                user: user,
                booking: booking
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loading = false;

                if (res.data.error == "no_error") {
                    done();
                } else {
                    var errorsFromServer = res.data.errors;

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");
                        alert(errors.error);
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loading = false;
                console.error(err);
            });

    }

    updateRide(done) {
        console.log("Update ride called");

        this.loading = true;

        var url = `${this.store.state.apiUrl}/booking/${this.booking.id}/update`;

        var booking = null;
        try {
            booking = this.makeBookingJSON(this.booking);
        } catch (e) {
            console.log("Error");
            console.log(e);
            this.loading = false;
            return;
        }

        var errors = this.errors;

        var vm = this;

        console.log("Updating ride on server");

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify({
                booking: booking,
                user: {
                    name: this.user.name,
                    contact_number: this.user.contact_number,
                },
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.loading = false;

                if (res.data.error == "no_error") {
                    done();
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                vm.loading = false;
                console.error(err);
            });

    }

    updateFinalCosts() {

        var url = `${this.store.state.apiUrl}/booking/${this.booking.id}/updateCosts?finalCost=${parseInt(this.booking.final_cost * 100)}`;

        if (this.booking.fixed_cost_driver == true) {
            url += `&finalCostDriver=${parseInt(this.booking.final_cost_driver * 100)}`;
        }

        var errors = this.errors;

        console.log("Updating final costs");

        axios({
            url: url,
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                if (res.data.error == "no_error") {
                    alert("Final Costs Updated");
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                console.error(err);
            });
    }

    updateNotes() {
        var url = `${this.store.state.apiUrl}/booking/${this.booking.id}/updateNotes?message=${this.booking.message}&notes=${this.booking.notes}`;

        console.log("Updating notes");

        var errors = this.errors;

        axios({
            url: url,
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                if (res.data.error == "no_error") {
                    alert("Messages Updated");
                } else {
                    var errorsFromServer = res.data.errors;

                    if (res.data.error != null) {
                        var message = "";

                        if (res.data.message != null) {
                            message = res.data.message;
                        }

                        errors.error = res.data.error + ": " + message;

                        console.log("Added plain error");

                        alert(errors.error);
                    }

                    for (var error in errorsFromServer) {
                        if (errorsFromServer.hasOwnProperty(error)) {
                            errors[error] = errorsFromServer[error];
                        }
                    }
                }

                console.log(errors);
            })
            .catch(function (err) {
                alert("Server Error");
                console.error(err);
            });
    }
    cancelRide(done, params) {
        console.log("Cancel called");

        var url = `${this.store.state.apiUrl}/booking/cancel/${this.booking.id}?chargeCancellationFee=${params.cancellationFee}&cancelOtherTripInPair=${params.cancelOtherTrip}`;

        axios({
            url: url,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {
                if (res.data.error == "no_error") {
                    done();
                    // alert("Booking Cancelled");
                    console.log("Cancelled trip");
                } else {
                    // todo better errors
                    alert(res.data.error);

                    if (res.data.message != null) {
                        alert(res.data.message);
                    }

                    console.log("Failed to cancel booking");
                }
            })
            .catch(function (err) {
                console.error(err);
            });
    }

    makeBookingJSON(booking, requireDestinations, requireFinalCost) {

        var makeBookingJSON = {};

        if (!booking.asap) {
            makeBookingJSON.pickup_time = moment(booking.pickup_datetime).format("YYYY-MM-DD HH:mm");
        }

        makeBookingJSON.business_customer_name = booking.business_customer_name;
        makeBookingJSON.business_customer_number = booking.business_customer_number;
        makeBookingJSON.business_customer_email = booking.business_customer_email;
        makeBookingJSON.business_customer_reference = booking.business_customer_reference;

        if (booking.taxi_type != null) {
            makeBookingJSON.taxi_type = booking.taxi_type;
        }

        if (booking.pickup_location.id == null) {
            this.errors.pickup_location = "Select pickup location";
        } else {
            makeBookingJSON.pickup_location = booking.pickup_location.id;
        }

        if (booking.pickup_info != null && booking.pickup_info.active == true) {
            makeBookingJSON.pickup_info = booking.pickup_info;
        }

        if (booking.destination_info != null && booking.destination_info.active == true) {
            makeBookingJSON.destination_info = booking.destination_info;
        }

        makeBookingJSON.destinations = [];

        for (var i = 0; i < booking.destinations.length; i++) {
            if (booking.destinations[i].id != null) {
                makeBookingJSON.destinations.push(booking.destinations[i].id);
            }
        }

        if (booking.destinations[0].id == null && requireDestinations == true) {
            console.log(booking);
            this.errors['destination_0'] = "Repeat booking requires destination locations";
        }

        makeBookingJSON.via_info = [];

        for (var j = 0; j < booking.via_info.length; j++) {
            if (booking.via_info[j] != null && booking.via_info[j].active == true) {
                makeBookingJSON.via_info.push(booking.via_info[j]);
            } else if (booking.via_info[j].active == false) {
                makeBookingJSON.via_info.push(BookingForm.emptyViaInfo());
            }
        }

        if (booking.promocode != null) {
            makeBookingJSON.promocode = booking.promocode;
        }

        makeBookingJSON.ride_type = booking.ride_type;

        makeBookingJSON.num_people = booking.num_people;

        if (booking.luggage != null) {
            makeBookingJSON.luggage = booking.luggage;
        } else {
            makeBookingJSON.luggage = 0;
        }

        makeBookingJSON.require_ppe = booking.require_ppe;

        makeBookingJSON.needs_disabled_access = booking.needs_disabled_access;
        makeBookingJSON.premium = booking.premium;

        if (booking.flight_number != null) {
            makeBookingJSON.flight_number = booking.flight_number;
        }

        if (booking.room_number != null) {
            makeBookingJSON.room_number = booking.room_number;
        }

        makeBookingJSON.meet_and_greet = booking.meet_and_greet;
        makeBookingJSON.needs_pets = booking.needs_pets;
        makeBookingJSON.payment_type = booking.payment_type;

        makeBookingJSON.authorized_by = booking.authorized_by;

        if (booking.payment_type == "card") {
            makeBookingJSON.card = booking.card;

            if (booking.card == null) {
                this.errors.card = "Select card";
            }
        }

        if (booking.additional_charge != null) {
            makeBookingJSON.additional_charge = booking.additional_charge * 100;
        } else {
            makeBookingJSON.additional_charge = 0;
        }

        if (booking.fixedCostType == this.FIXED_COST_DISPATCHER() && booking.fixed_cost == true) {
            makeBookingJSON.fixed_cost = booking.fixed_cost;
            makeBookingJSON.final_cost = booking.final_cost * 100;
        }

        // if (booking.final_cost == 0 && requireFinalCost == true) {
        //     this.errors.final_cost = "Repeat booking requires a fixed final cost";
        // }

        if (booking.fixedCostDriverType == this.FIXED_COST_DISPATCHER() && booking.fixed_cost_driver == true) {
            makeBookingJSON.fixed_cost_driver = booking.fixed_cost_driver;
            makeBookingJSON.final_cost_driver = booking.final_cost_driver * 100;
        }

        makeBookingJSON.manual_dispatch = booking.manual_dispatch;

        if (booking.preassigned_driver != null) {
            makeBookingJSON.preassigned_driver = booking.preassigned_driver;
        }

        makeBookingJSON.notes = booking.notes;

        makeBookingJSON.message = booking.message;

        if (booking.predefinedMessage != null) {
            makeBookingJSON.message = booking.predefinedMessage + "\n" + booking.message;
        }

        console.log(makeBookingJSON);

        return makeBookingJSON;
    }


    static jsonToBookingFormBookingUser(jsonBookingUser) {

        console.log(jsonBookingUser);

        var booking = BookingForm.emptyBooking();

        var jsonBooking = jsonBookingUser.booking;
        var jsonUser = jsonBookingUser.booking.user;
        var jsonReviews = jsonBookingUser.reviews;

        if (!jsonBooking.asap) {
            booking.asap = false;

            var date = moment(jsonBooking.pickup_time, "DD/MM/YYYY HH:mm");

            booking.pickup_datetime = date;

            booking.pickup_date = date.format("YYYY-MM-DD");
            booking.pickup_time = date.format("HH:mm");

        } else {
            booking.asap = true;

            var date = moment(jsonBooking.pickup_time, "DD/MM/YYYY HH:mm");

            booking.pickup_datetime = date;

            booking.pickup_date = date.format("YYYY-MM-DD");
            booking.pickup_time = date.format("HH:mm");
        }

        booking.id = jsonBooking.id;

        booking.business_customer_name = jsonBooking.business_customer_name;
        booking.business_customer_number = jsonBooking.business_customer_number;
        booking.business_customer_email = jsonBooking.business_customer_email;
        booking.business_customer_reference = jsonBooking.business_customer_reference;

        booking.pickup_location = jsonBooking.pickup_location;
        booking.pickup_location.latLng = {
            latitude: booking.pickup_location.lat,
            longitude: booking.pickup_location.lon,
        };

        if (jsonBooking.pickup_info != null) {
            booking.pickup_info = jsonBooking.pickup_info;
            booking.pickup_info.active = true;
        }

        if (jsonBooking.destination_info != null) {
            booking.destination_info = jsonBooking.destination_info;
            booking.destination_info.active = true;
        }

        if (jsonBooking.destinations != null && jsonBooking.destinations.length > 0) {

            booking.destinations = [];

            for (var i = 0; i < jsonBooking.destinations.length; i++) {
                booking.destinations.push(jsonBooking.destinations[i]);

                booking.destinations[i].latLng = {
                    latitude: booking.destinations[i].lat,
                    longitude: booking.destinations[i].lon,
                };

                if (i > 0) {
                    try {
                        if (jsonBooking.via_info != null) {
                            if (jsonBooking.via_info[i - 1] != null) {
                                booking.via_info.push(jsonBooking.via_info[i - 1]);
                                booking.via_info[i - 1].active = true;
                            } else {
                                booking.via_info.push(this.emptyViaInfo());
                            }
                        } else {
                            booking.via_info.push(this.emptyViaInfo());
                        }
                    } catch (e) {
                        booking.via_info.push(this.emptyViaInfo());
                        console.log(e);
                    }
                }
            }
        }

        if (jsonBooking.promocode != null) {
            booking.promocode = jsonBooking.promocode.id;
        }

        if (jsonBooking.ride_type != null) {
            booking.ride_type = jsonBooking.ride_type;
        }

        booking.require_ppe = jsonBooking.require_ppe;

        booking.num_people = jsonBooking.num_people;
        booking.luggage = jsonBooking.luggage;
        booking.needs_disabled_access = jsonBooking.needs_disabled_access;
        booking.premium = jsonBooking.premium;

        booking.booking_type = jsonBooking.booking_type;

        if (jsonBooking.flight_number != null) {
            booking.flight_number = jsonBooking.flight_number;
        }

        if (jsonBooking.room_number != null) {
            booking.room_number = jsonBooking.room_number;
        }

        booking.meet_and_greet = jsonBooking.meet_and_greet;
        booking.needs_pets = jsonBooking.needs_pets;

        booking.payment_type = jsonBooking.payment_type;
        booking.card_payment_type = jsonBooking.card_payment_type;

        booking.cart = jsonBookingUser.cart;

        if (jsonBooking.payment_type == "card") {
            booking.card = jsonBooking.card;
        }

        booking.taxi_type = jsonBooking.taxi_type;

        if (booking.taxi_type != null) {
            booking.taxi_type = booking.taxi_type.replace(/^\w/, c => c.toUpperCase());
        }

        booking.additional_charge = jsonBooking.additional_charge / 100.0;

        booking.state = jsonBooking.state;

        booking.fixed_cost = jsonBooking.fixed_cost;

        booking.final_cost = jsonBooking.final_cost / 100.0;

        if (jsonBooking.final_cost_promotion != null) {
            booking.final_cost_promotion = jsonBooking.final_cost_promotion / 100.0;
        }

        if (jsonBooking.fixed_cost_type != null) {
            booking.fixedCostType = jsonBooking.fixed_cost_type;
        }

        booking.final_cost_driver = jsonBooking.fixed_cost_driver / 100.0;

        if (jsonBooking.fixed_cost_driver_type != null) {
            booking.fixedCostDriverType = jsonBooking.fixed_cost_driver_type;
            booking.fixed_cost_driver = true;
        }

        if (jsonBooking.notes != null) {
            booking.notes = jsonBooking.notes;
        }

        if (jsonBooking.message != null) {
            booking.message = jsonBooking.message;
        }

        booking.created_at = jsonBooking.created_at;
        booking.accept_time = jsonBooking.accept_time;
        booking.arrived_time = jsonBooking.arrived_time;
        booking.pob_time = jsonBooking.pob_time;
        booking.finished_time = jsonBooking.finished_time;
        booking.estimated_dispatch_time = jsonBooking.estimated_dispatch_time;

        booking.card_status = jsonBooking.card_status;
        booking.card_status_reason = jsonBooking.card_status_reason;

        booking.cancellation_type = jsonBooking.cancellation_type;
        booking.cancellation_reason = jsonBooking.cancellation_reason;
        booking.cancellation_description = jsonBooking.cancellation_description;

        booking.route = jsonBooking.route == null ? {} : jsonBooking.route;
        booking.route.time = jsonBooking.estimated_time == null ? 0 : jsonBooking.estimated_time;

        booking.manual_dispatch = jsonBooking.manual_dispatch;

        booking.sumup_transaction = jsonBooking.sumup_transaction;
        booking.refunded = jsonBooking.refunded;

        booking.track_booking_url = jsonBooking.track_booking_url;

        booking.authorized_by = jsonBooking.authorized_by;
        booking.booked_by = jsonBooking.booked_by;

        if (jsonBooking.preassigned_driver != null) {
            console.log("Preassigned driver not null - " + jsonBooking.preassigned_driver.driver.id);
            booking.preassigned_driver = jsonBooking.preassigned_driver.driver.id;

            booking.eligibleDriversForPreassign = [{
                id: jsonBooking.preassigned_driver.driver.id,
                callsign: jsonBooking.preassigned_driver.driver.callsign,
                name: jsonBooking.preassigned_driver.driver.name
            },];
        } else {
            console.log("Preassigned driver null");
            booking.eligibleDriversForPreassign = [];
            booking.preassigned_driver = null;
        }

        booking.driver_trace = jsonBooking.driver_trace;

        booking.dispatched_by = jsonBooking.dispatched_by;

        booking.driver = jsonBooking.driver;

        if (booking.fixed_cost == false && booking.state != 'completed') {
            console.log("Setting final cost to null");
            booking.final_cost = null;
        }

        if (jsonBooking.fixed_cost_driver_type == undefined) {
            console.log("Setting final cost driver to null");
            booking.final_cost_driver = null;
        }


        var user = BookingForm.emptyUser();

        try {
            user.id = jsonUser.id;
            user.name = jsonUser.name;
            user.contact_number = jsonUser.contact_number;
            user.email = jsonUser.email;
            user.cards = jsonUser.cards;
            user.promocodes = jsonUser.promocodes;
            user.business = jsonUser.business;
            user.business_pickup_address =
                jsonUser.business_pickup_address;
            user.notes = jsonUser.notes;
            user.recent_bookings = jsonUser.recent_bookings;
            user.active_bookings = jsonUser.active_bookings;
            user.locked_out = jsonUser.locked_out;
        } catch (e) {
            console.log(e);
        }

        return {
            booking: booking,
            user: user,
            reviews: jsonReviews,
        };
    }
}